import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';
import { sendConfirmationRequestBody } from './types';
import { Session } from 'services/session';

const CONFIRMATION_REQUEST = (id: number) =>
  `/v2/teacher/unit/${id}/confirm-request`;

export type SendConfirmationRequestRes = {
  session: Session;
};
export const sendConfirmationRequest = ({
  id,
}: sendConfirmationRequestBody) => {
  return httpClient.post<SendConfirmationRequestRes>(
    CONFIRMATION_REQUEST(id),
    {},
  );
};

export const useSendConfirmationRequest = (
  opts?: UseMutationOptions<
    AxiosResponse<SendConfirmationRequestRes>,
    AxiosError<any>,
    sendConfirmationRequestBody
  >,
) =>
  useMutation<
    AxiosResponse<SendConfirmationRequestRes>,
    AxiosError<any>,
    sendConfirmationRequestBody
  >(sendConfirmationRequest, opts);
